export default __webpack_public_path__ + "static/media/apple_mini.ab7d5aec.png";